import { useSections } from "@/contexts/classified";
import { addSources, buildMasonryArray, getOriginIndex } from "@/gallery/utils";
export const useFloorplans = () => {
    var _a, _b, _c;
    const floorplans = (_c = (_b = (_a = useSections()) === null || _a === void 0 ? void 0 : _a.gallery) === null || _b === void 0 ? void 0 : _b.floorplans) !== null && _c !== void 0 ? _c : [];
    const optimizedFloorPlans = floorplans.map((floorplan) => {
        const urlMedium = new URL(floorplan.url);
        urlMedium.searchParams.set("w", "768");
        urlMedium.searchParams.set("h", "560");
        return {
            ...floorplan,
            id: floorplan === null || floorplan === void 0 ? void 0 : floorplan.key,
            url: urlMedium.href,
        };
    });
    return {
        floorplansCount: floorplans.length,
        floorplansDesktopPreview: optimizedFloorPlans.slice(0, 3),
        floorplansFullscreen: floorplans
            .map(addSources("fullscreen"))
            .map(getOriginIndex),
        floorplansMobilePreview: optimizedFloorPlans,
        masonryFloorplans: buildMasonryArray(floorplans),
    };
};
